import label from "@/lang/StaticLabels.js";

// PBANK Router  - خزانه -----------------------------------------------
let routeItems = {
  path: "PBANK",
  name: "PBANK",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PBANKDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PBANKDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pbank,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/Dashboard"),
    },
    {
      path: "bankAccount",
      name: "PBANKBankAccount",
      meta: {
        label: label.page.bankAccountInfo,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/base/bankInfo"),
    },
    {
      path: "cashAccount",
      name: "PBANKCashAccount",
      meta: {
        label: label.page.cashAccount,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/base/cashInfo"),
    },
    {
      path: "checks",
      name: "PBANKChecks",
      meta: {
        label: label.page.checks,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/base/checks"),
    },
    {
      path: "chequeStatus",
      name: "PBANKChequeStatus",
      meta: {
        label: label.page.chequeStatus,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/base/chequeStatus"),
    },
 
    {
      path: "receiveAndPay",
      name: "PBANKReceiveAndPay",
      meta: {
        label: label.page.receiveAndPay,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/base/recevieAndPay"),
    },
    {
      path: "issueTrackingType",
      name: "PBANKIssueTrackingType",
      meta: {
        label: label.page.issueTrackingType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/base/issueTrackingType"),
    },
    {
      path: "receiveCash",
      name: "PBANKReceiveCash",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "receiveCash/list",
      children: [
        {
          path: "list",
          name: "PBANKReceiveCashList",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCash"),
          meta: {
            label: label.page.receiveCash,
            requiresAuth: true,
          },
        },
        {
          path: "voucherCartable",
          name: "PBANKReceiveCashVoucherCartable",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCash"),
          meta: {
            label: label.page.receiveCashVoucherCartable,
            requiresAuth: true,
            isVoucherCartable: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddReceiveCash",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCash/Add"),
          meta: {
            label: label.page.addReceiveCash,
            requiresAuth: true,
          },
        },
        {
          path: "addGroup",
          name: "PBANKAddReceiveCashGroup",
          component: () =>
            import(
              "@/views/modules/pbank/operation/receiveCash/AddGroupResponsive"
            ),
          meta: {
            label: label.page.addReceiveCashGroup,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditReceiveCash",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCash/Add"),
          meta: {
            label: label.page.editReceiveCash,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "paymentCash",
      name: "PBANKPaymentCash",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "paymentCash/list",
      children: [
        {
          path: "list",
          name: "PBANKPaymentCashList",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCash"),
          meta: {
            label: label.page.paymentCash,
            requiresAuth: true,
          },
        },
        {
          path: "voucherCartable",
          name: "PBANKPaymentCashVoucherCartable",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCash"),
          meta: {
            label: label.page.paymentCashVoucherCartable,
            requiresAuth: true,
            isVoucherCartable: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddPaymentCash",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCash/Add"),
          meta: {
            label: label.page.addPaymentCash,
            requiresAuth: true,
          },
        },
        {
          path: "addGroup",
          name: "PBANKAddPaymentCashGroup",
          component: () =>
            import(
              "@/views/modules/pbank/operation/paymentCash/AddGroupResponsive"
            ),
          meta: {
            label: label.page.addPaymentCashGroup,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditPaymentCash",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCash/Add"),
          meta: {
            label: label.page.editPaymentCash,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "paymentRequest",
      name: "PBANKPaymentRequest",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "paymentRequest/list",
      children: [
        {
          path: "list",
          name: "PBANKPaymentRequestList",
          component: () =>
            import("@/views/modules/pbank/operation/paymentRequest"),
          meta: {
            label: label.page.paymentRequest,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddPaymentRequest",
          component: () =>
            import("@/views/modules/pbank/operation/paymentRequest/Add"),
          meta: {
            label: label.page.addPaymentRequest,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditPaymentRequest",
          component: () =>
            import("@/views/modules/pbank/operation/paymentRequest/Add"),
          meta: {
            label: label.page.editPaymentRequest,
            requiresAuth: true,
          },
        },
        {
          path: "confirmRequest",
          name: "PBANKPaymentRequestConfirm",
          component: () =>
            import("@/views/modules/pbank/operation/paymentRequest/Confirm"),
          meta: {
            label: label.page.paymentRequestConfirm,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "receiveCheque",
      name: "PBANKReceiveCheque",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "receiveCheque/list",
      children: [
        {
          path: "list",
          name: "PBANKReceiveChequeList",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCheque"),
          meta: {
            label: label.page.receiveCheque,
            requiresAuth: true,
          },
        },
        {
          path: "voucherCartable",
          name: "PBANKReceiveChequeVoucherCartable",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCheque"),
          meta: {
            label: label.page.receiveChequeVoucherCartable,
            requiresAuth: true,
            isVoucherCartable: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddReceiveCheque",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCheque/Add"),
          meta: {
            label: label.page.addReceiveCheque,
            requiresAuth: true,
          },
        },
        {
          path: "addGroup",
          name: "PBANKAddReceiveChequeGroup",
          component: () =>
            import(
              "@/views/modules/pbank/operation/receiveCheque/AddGroupResponsive"
            ),
          meta: {
            label: label.page.addReciveChequeGroup,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditReceiveCheque",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCheque/Add"),
          meta: {
            label: label.page.editReceiveCheque,
            requiresAuth: true,
          },
        },
        {
          path: "cartable",
          name: "PBANKReceiveChequeCartable",
          component: () =>
            import("@/views/modules/pbank/operation/receiveCheque/cartable"),
          meta: {
            label: label.page.receiveChequeConfirm,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "bankTransfer",
      name: "PBANKBankTransfer",
      meta: {
        label: label.page.bankTransfer,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pbank/operation/receiveCheque/bankTransfer"),
    },
    {
      path: "assignmentPerson",
      name: "PBANKAssignmentPerson",
      meta: {
        label: label.page.assignmentPerson,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbank/operation/receiveCheque/assignmentPerson"
        ),
    },
    {
      path: "settlement",
      name: "PBANKSettlement",
      meta: {
        label: label.page.settlement,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pbank/operation/receiveCheque/settlement"),
    },
    {
      path: "returnTransferred",
      name: "PBANKReturnTransferred",
      meta: {
        label: label.page.returnTransferred,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbank/operation/receiveCheque/returnTransferred"
        ),
    },
    {
      path: "cancellationReceivable",
      name: "PBANKCancellationReceivable",
      meta: {
        label: label.page.cancellationReceivable,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbank/operation/receiveCheque/cancellationReceivable"
        ),
    },
    {
      path: "returnReceivables",
      name: "PBANKReturnReceivables",
      meta: {
        label: label.page.returnReceivables,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbank/operation/receiveCheque/returnReceivables"
        ),
    },
    {
      path: "returnGuarantee",
      name: "PBANKReturnGuarantee",
      meta: {
        label: label.page.returnGuarantee,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pbank/operation/receiveCheque/returnGuarantee"),
    },
    {
      path: "returnAssignment",
      name: "PBANKReturnAssignment",
      meta: {
        label: label.page.returnAssignment,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbank/operation/receiveCheque/returnAssignment"
        ),
    },
    {
      path: "paymentCheque",
      name: "PBANKPaymentCheque",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "paymentCheque/list",
      children: [
        {
          path: "list",
          name: "PBANKPaymentChequeList",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCheque"),
          meta: {
            label: label.page.paymentCheque,
            requiresAuth: true,
          },
        },
        {
          path: "voucherCartable",
          name: "PBANKPaymentChequeVoucherCartable",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCheque"),
          meta: {
            label: label.page.paymentChequeVoucherCartable,
            requiresAuth: true,
            isVoucherCartable: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddPaymentCheque",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCheque/Add"),
          meta: {
            label: label.page.addPaymentCheque,
            requiresAuth: true,
          },
        },
        {
          path: "addGroup",
          name: "PBANKAddPaymentChequeGroup",
          component: () =>
            import(
              "@/views/modules/pbank/operation/paymentCheque/AddGroupResponsive"
            ),
          meta: {
            label: label.page.addPaymentChequeGroup,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditPaymentCheque",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCheque/Add"),
          meta: {
            label: label.page.editPaymentCheque,
            requiresAuth: true,
          },
        },
        {
          path: "cartable",
          name: "PBANKpaymentChequeCartable",
          component: () =>
            import("@/views/modules/pbank/operation/paymentCheque/cartable"),
          meta: {
            label: label.page.paymentChequeConfirm,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "passPayDocs",
      name: "PBANKPassPayDocs",
      meta: {
        label: label.page.passPayDocs,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pbank/operation/paymentCheque/passPayDocs"),
    },
    {
      path: "cancelPayableDocs",
      name: "PBANKCancelPayableDocs",
      meta: {
        label: label.page.cancelPayableDocs,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbank/operation/paymentCheque/cancelPayableDocs"
        ),
    },

    {
      path: "returnGuaranteeDocs",
      name: "PBANKReturnGuaranteeDocs",
      meta: {
        label: label.page.returnGuarantee,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pbank/operation/paymentCheque/returnGuaranteeDocs"
        ),
    },
    {
      path: "cartableLog",
      name: "PBANKCartableLog",
      meta: {
        label: label.page.cartableLog,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/operation/cartableLog"),
    },

    {
      path: "receiptReceived",
      name: "PBANKReceiptReceived",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "receiveCash/list",
      children: [
        {
          path: "list",
          name: "PBANKReceiptReceivedList",
          component: () =>
            import("@/views/modules/pbank/operation/receiptReceived/index.vue"),
          meta: {
            label: label.page.receiptReceived,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddReceiptReceived",
          component: () =>
            import("@/views/modules/pbank/operation/receiptReceived/add.vue"),
          meta: {
            label: label.page.addReceiptReceived,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditReceiptReceived",
          component: () =>
            import("@/views/modules/pbank/operation/receiptReceived/add.vue"),
          meta: {
            label: label.page.editReceiptReceived,
            requiresAuth: true,
          },
        },
        {
          path: "receiptReceiveCartabl",
          name: "PBANKReceiptReceiveCartabl",
          component: () =>
            import(
              "@/views/modules/pbank/operation/receiptReceived/Cartable.vue"
            ),
          meta: {
            label: label.page.addReceiptReceiveCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "payment",
      name: "PBANKPaymentPaper",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "paymentlist",
      children: [
        {
          path: "list",
          name: "PBANKPaymentPaperList",
          component: () =>
            import("@/views/modules/pbank/operation/paymentPaper/index.vue"),
          meta: {
            label: label.page.paymentPaper,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddPaymentPaper",
          component: () =>
            import("@/views/modules/pbank/operation/paymentPaper/add.vue"),
          meta: {
            label: label.page.addPaymentPaper,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditPaymentPaper",
          component: () =>
            import("@/views/modules/pbank/operation/paymentPaper/add.vue"),
          meta: {
            label: label.page.editPaymentPaper,
            requiresAuth: true,
          },
        },
        {
          path: "papersCartable",
          name: "PBANKPaymentPapersCartable",
          component: () =>
            import("@/views/modules/pbank/operation/paymentPaper/cartable"),
          meta: {
            label: label.page.paymentPapersCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "managementCartable",
      name: "PBANKManagementCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "managementCartable/paymentCheque",
      children: [
        {
          path: "paymentCheque",
          name: "PBANKManagementCartablePaymentCheque",
          component: () =>
            import(
              "@/views/modules/pbank/operation/managementCartable/PaymentCheque"
            ),
          meta: {
            label: label.page.managementCartablePaymentCheque,
            requiresAuth: true,
          },
        },
        {
          path: "paymentRequest",
          name: "PBANKManagementCartablePaymentRequest",
          component: () =>
            import(
              "@/views/modules/pbank/operation/managementCartable/PaymentRequest"
            ),
          meta: {
            label: label.page.managementCartablePaymentRequest,
            requiresAuth: true,
          },
        },
        {
          path: "receiveCheque",
          name: "PBANKManagementCartableReceiveCheque",
          component: () =>
            import(
              "@/views/modules/pbank/operation/managementCartable/ReceiveCheque"
            ),
          meta: {
            label: label.page.managementCartableReceiveCheque,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "interbankTransfer",
      name: "PBANKInterBankTransfer",
      component: {
        render(c) {
          return c("router-view");
        }, 
      },
      redirect: "interbankTransferlist",
      children: [
        {
          path: "list",
          name: "PBANKInterBankTransferList",
          component: () =>
            import("@/views/modules/pbank/operation/bankTransfer"),
          meta: {
            label: label.page.interbankTransfer,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PBANKAddInterBankTransfer",
          component: () =>
            import("@/views/modules/pbank/operation/bankTransfer/Add"),
          meta: {
            label: label.page.addInterbankTransfer,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PBANKEditInterBankTransfer",
          component: () =>
            import("@/views/modules/pbank/operation/bankTransfer/Add"),
          meta: {
            label: label.page.editInterbankTransfer,
            requiresAuth: true,
          },
        },
      ],
    },

    // Reports -----------------------------------------------
    {
      path: "reports",
      name: "PBANKReports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "reports/someVouchers",
      children: [
        {
          path: "receiveCheque",
          name: "PBANKReceiveChequeReport",
          component: () =>
            import("@/views/modules/pbank/reports/receiveCheque"),
          meta: {
            label: label.page.receiveCheque,
            requiresAuth: true,
          },
        },
        {
          path: "receiveAndPaymentCash",
          name: "PBANKReceiveAndPaymentCashReport",
          component: () =>
            import("@/views/modules/pbank/reports/receiveAndPaymentCash"),
          meta: {
            label: label.page.receiveAndPaymentCash,
            requiresAuth: true,
          },
        },
        {
          path: "bankAccountOperationDetail",
          name: "PBANKBankAccountOperationDetailReport",
          component: () =>
            import("@/views/modules/pbank/reports/bankAccountOperationDetail"),
          meta: {
            label: label.page.bankAccountOperationDetail,
            requiresAuth: true,
          },
        },
        {
          path: "monthlyReceiveAndPaymentCashReport",
          name: "PBANKMonthlyReceiveAndPaymentCashReport",
          component: () =>
            import(
              "@/views/modules/pbank/reports/monthlyReceiveAndPaymentCashReport"
            ),
          meta: {
            label: label.page.monthlyReceiveAndPaymentCashReport,
            requiresAuth: true,
          },
        },
        {
          path: "cashFlowReport",
          name: "PBANKCashFlowReport",
          component: () =>
            import(
              "@/views/modules/pbank/reports/cashFlow"
            ),
          meta: {
            label: label.page.cashFlowReport,
            requiresAuth: true,
          },
        },
        {
          path: "historyReceiveCheque",
          name: "PBANKHistoryReceiveChequeReport",
          component: () =>
            import("@/views/modules/pbank/reports/historyReceiveCheque"),
          meta: {
            label: label.page.historyReceiveChequeReport,
            requiresAuth: true,
          },
        },
        {
          path: "historyPaymentCheque",
          name: "PBANKHistoryPaymentChequeReport",
          component: () =>
            import("@/views/modules/pbank/reports/historyPaymentCheque"),
          meta: {
            label: label.page.historyPaymentChequeReport,
            requiresAuth: true,
          },
        },
        {
          path: "paymentCheque",
          name: "PBANKPaymentChequeReport",
          component: () =>
            import("@/views/modules/pbank/reports/paymentCheque"),
          meta: {
            label: label.page.paymentChequeReport,
            requiresAuth: true,
          },
        },
        {
          path: "checksReceivedDueed",
          name: "PBANKPastDueChecksReport",
          component: () =>
            import("@/views/modules/pbank/reports/checksReceivedDueed"),
          meta: {
            label: label.page.checksReceivedDueed,
            requiresAuth: true,
          },
        },
        {
          path: "monthlyComparisonReceiveCheque",
          name: "PBANKMonthlyComparisonReceiveChequeReport",
          component: () =>
            import(
              "@/views/modules/pbank/reports/monthlyComparisonReceiveCheque"
            ),
          meta: {
            label: label.page.monthlyComparisonReceiveCheque,
            requiresAuth: true,
          },
        },
        {
          path: "monthlyComparisonPaymentCheque",
          name: "PBANKMonthlyComparisonPaymentChequeReport",
          component: () =>
            import(
              "@/views/modules/pbank/reports/monthlyComparisonPaymentCheque"
            ),
          meta: {
            label: label.page.monthlyComparisonPaymentCheque,
            requiresAuth: true,
          },
        },
        {
          path: "paymentChequeToPerson",
          name: "PBANKPaymentChequeToPersonReport",
          component: () =>
            import("@/views/modules/pbank/reports/paymentChequeToPerson"),
          meta: {
            label: label.page.paymentChequeToPerson,
            requiresAuth: true,
          },
        },
        {
          path: "paymentChequeToAccountInfo",
          name: "PBANKPaymentChequeToAccountInfoReport",
          component: () =>
            import("@/views/modules/pbank/reports/paymentChequeToAccountInfo"),
          meta: {
            label: label.page.paymentChequeToAccountInfo,
            requiresAuth: true,
          },
        },
        {
          path: "paymentChequeTurn",
          name: "PBANKPaymentChequeTurnReport",
          component: () =>
            import("@/views/modules/pbank/reports/paymentChequeTurn"),
          meta: {
            label: label.page.paymentChequeTurn,
            requiresAuth: true,
          },
        },
        {
          path: "inventoryReport",
          name: "PBANKAccountInventoryReport",
          component: () =>
            import("@/views/modules/pbank/reports/inventoryReport"),
          meta: {
            label: label.page.accountInventoryReport,
            requiresAuth: true,
          },
        },
        {
          path: "summaryReceiveCheque",
          name: "PBANKSummaryReceiveChequeReport",
          component: () =>
            import("@/views/modules/pbank/reports/summaryReceiveCheque"),
          meta: {
            label: label.page.summaryReceiveCheque,
            requiresAuth: true,
          },
        },
        {
          path: "summaryPaymentCheque",
          name: "PBANKSummaryPaymentChequeReport",
          component: () =>
            import("@/views/modules/pbank/reports/summaryPaymentCheque"),
          meta: {
            label: label.page.summaryPaymentCheque,
            requiresAuth: true,
          },
        },
        {
          path: "bankSummary",
          name: "PBANKSummaryReport",
          component: () => import("@/views/modules/pbank/reports/bankSummary"),
          meta: {
            label: label.page.bankSummary,
            requiresAuth: true,
          },
        },
        {
          path: "checksPaymentDueed",
          name: "PBANKPastDuePaymentChecksReport",
          component: () =>
            import("@/views/modules/pbank/reports/checksPaymentDueed"),
          meta: {
            label: label.page.checksPaymentDueed,
            requiresAuth: true,
          },
        },
        {
          path: "receiveChequeTurn",
          name: "PBANKReceiveChequeTurnReport",
          component: () =>
            import("@/views/modules/pbank/reports/receivChequeTurn"),
          meta: {
            label: label.page.receiveChequeTurnReprot,
            requiresAuth: true,
          },
        },
      ],
    },
  ],
};

export default routeItems;
